import { useEffect, useState } from "react"
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { useNavigate } from "react-router-dom";
import { CHAVE_TOKEN, real } from "../../../utils/formata";
import { Vazio, EsqueletoLista } from "../../Components/Estado";

const rotulos = {
    analise: "Em análise",
    ativo: "Ativo",
    quitado: "Quitado",
    cancelado: "Cancelado",
};

export default function EmprestimoConsulta() {
    const [emprestimos, setEmprestimos] = useState([]);
    const [filtroStatus, setFiltroStatus] = useState("");
    const [busca, setBusca] = useState("");
    const [carregando, setCarregando] = useState(true);
    const { consultarEmprestimos } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    useEffect(() => {
        if (!!localStorage.getItem(CHAVE_TOKEN)) {
            consultarEmprestimos()
                .then((data) => setEmprestimos(data || []))
                .catch((error) => setErroPadrao(error))
                .finally(() => setCarregando(false));
        } else {
            navigate("/login");
        }
    }, [consultarEmprestimos, setErroPadrao, navigate]);

    const termo = busca.trim().toLowerCase();
    const filtrados = emprestimos.filter((e) => {
        if (filtroStatus && e.status !== filtroStatus) return false;
        if (!termo) return true;
        const emp = e.Empresa || {};
        return `${emp.nomeFantasia || ""} ${emp.razaoSocial || ""} ${emp.cnpj || ""} ${emp.telefone || ""} #${e.id}`
            .toLowerCase()
            .includes(termo);
    });
    const ativos = emprestimos.filter((e) => e.status === "ativo");
    const naRua = ativos.reduce((s, e) => s + Number(e.saldoDevedor || 0), 0);
    const contratosEmAtraso = emprestimos.filter((e) => e.parcelasAtrasadas > 0).length;

    return (
        <div className="pagina">
            <div className="cabecalho-pagina">
                <h2 className="he-titulo" style={{margin: 0}}>Empréstimos <span className="he-dourado">& Contratos</span></h2>
                <button className="btn btn-he" onClick={() => navigate("/cadastro-emprestimo")}><i className="bi bi-plus-lg"></i> Novo Empréstimo</button>
            </div>

            {!carregando && emprestimos.length > 0 &&
                <div className="he-card" style={{marginTop: "1em", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px 20px"}}>
                    <div style={{minWidth: 0}}>
                        <div className="estat-rotulo">Na rua · saldo devedor</div>
                        <div style={{fontSize: "clamp(1.7rem, 8vw, 2.3rem)", fontWeight: 800, color: "#d4af37", lineHeight: 1.05}}>{real(naRua)}</div>
                        <div style={{fontSize: "0.78rem", color: "#9aa5b5"}}>{ativos.length} contrato{ativos.length === 1 ? "" : "s"} ativo{ativos.length === 1 ? "" : "s"}</div>
                    </div>
                    <div style={{display: "flex", gap: 22}}>
                        <div style={{textAlign: "center"}}>
                            <div style={{fontSize: "1.5rem", fontWeight: 800, color: "#4da3ff", lineHeight: 1}}>{emprestimos.filter((e) => e.status === "analise").length}</div>
                            <div className="estat-rotulo" style={{marginTop: 2}}>Em análise</div>
                        </div>
                        <div style={{textAlign: "center"}}>
                            <div style={{fontSize: "1.5rem", fontWeight: 800, color: contratosEmAtraso > 0 ? "#ff6b5b" : "#2ecc71", lineHeight: 1}}>{contratosEmAtraso}</div>
                            <div className="estat-rotulo" style={{marginTop: 2}}>Com atraso</div>
                        </div>
                    </div>
                </div>
            }

            <div style={{position: "relative", margin: "1.2em 0 0.8em", maxWidth: 460}}>
                <i className="bi bi-search" style={{position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9aa5b5"}}></i>
                <input className="form-control" style={{paddingLeft: 36}} placeholder="Buscar por nome, CNPJ/CPF ou nº do contrato..." value={busca} onChange={(e) => setBusca(e.target.value)}/>
                {busca && <button type="button" className="btn btn-sm btn-outline-he" style={{position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", padding: "2px 8px"}} onClick={() => setBusca("")}><i className="bi bi-x"></i></button>}
            </div>

            <div className="filtros-status" style={{margin: "0 0 1em"}}>
                {["", "analise", "ativo", "quitado", "cancelado"].map((s) => (
                    <button key={s} className={`btn btn-sm ${filtroStatus === s ? "btn-he" : "btn-outline-he"}`} onClick={() => setFiltroStatus(s)}>
                        {s === "" ? "Todos" : rotulos[s]}
                    </button>
                ))}
            </div>

            {carregando ? <EsqueletoLista quantidade={4}/> :
            filtrados.length === 0 ?
            <div className="he-card sem-rolagem">
                <Vazio icone="bi bi-file-earmark-text" titulo={busca ? "Nenhum contrato encontrado" : filtroStatus ? "Nenhum contrato nesse filtro" : "Nenhum empréstimo ainda"}
                       texto={busca ? `Nada bate com "${busca}". Confere o nome ou o número do contrato.` : filtroStatus ? "Troque o filtro acima para ver os outros contratos." : "Cadastre o primeiro contrato e ele aparece aqui com parcelas e cobrança."}
                       acao={!filtroStatus && !busca && <button className="btn btn-he" onClick={() => navigate("/cadastro-emprestimo")}><i className="bi bi-plus-lg"></i> Novo Empréstimo</button>}/>
            </div>
            :
            <div className="he-card sem-rolagem">
                <div className="tabela-rolavel rolagem-so-desktop">
                <table className="table table-striped table-hover tabela-responsiva">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Empresa</th>
                            <th>Emprestado</th>
                            <th>Total c/ juros</th>
                            <th>Parcelas</th>
                            <th>Saldo devedor</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtrados.map((e) => (
                            <tr key={e.id} className="linha-clicavel" style={{cursor: "pointer"}} onClick={() => navigate(`/emprestimo/${e.id}`)}>
                                <td className="esconder-mobile" data-rotulo="#">#{e.id}</td>
                                <td className="principal" data-rotulo="Empresa" style={{fontWeight: 600}}>
                                    {e.Empresa?.nomeFantasia || e.Empresa?.razaoSocial}
                                    <div className="so-mobile" style={{fontSize: "0.78rem", color: "#a3aec0", fontWeight: 600, marginTop: 2}}>Contrato #{e.id}</div>
                                </td>
                                <td className="valor-dinheiro" data-rotulo="Emprestado">{real(e.valorPrincipal)}</td>
                                <td className="valor-dinheiro" data-rotulo="Total c/ juros">{real(e.valorTotal)}<div style={{fontSize: "0.78rem", color: "#a3aec0"}}>{Number(e.taxaJuros)}% a.m. · {e.metodoJuros}</div></td>
                                <td data-rotulo="Parcelas">{e.parcelasPagas}/{e.numParcelas}{e.parcelasAtrasadas > 0 && <span className="badge badge-atrasada" style={{marginLeft: 6}}>{e.parcelasAtrasadas} atrasada{e.parcelasAtrasadas > 1 ? "s" : ""}</span>}</td>
                                <td className="destaque valor-dinheiro" data-rotulo="Saldo devedor" style={{color: "#d4af37"}}>{real(e.saldoDevedor)}</td>
                                <td data-rotulo="Status"><span className={`badge badge-${e.status}`}>{rotulos[e.status] || e.status}</span></td>
                                <td className="acoes">
                                    <i className="bi bi-chevron-right esconder-mobile" style={{color: "#9aa5b5"}}></i>
                                    <span className="btn btn-outline-he so-mobile">Ver detalhes <i className="bi bi-chevron-right"></i></span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
            </div>}
        </div>
    )
}
